import { AbstractReactFactory } from '@projectstorm/react-canvas-core'
import DuprNodeModel from './DuprNodeModel'
import DuprNodeWidget from './DuprNodeWidget'

export default class DuprNodeFactory extends AbstractReactFactory {
  constructor() {
    super('js-custom-node')
  }

  generateModel() {
    return new DuprNodeModel()
  }

  generateReactWidget(event: any) {
    return <DuprNodeWidget engine={this.engine} node={event.model} />
  }
}
